import { render, staticRenderFns } from "./AbcdQuestionEditor.vue?vue&type=template&id=2709d4b0&scoped=true&"
import script from "./AbcdQuestionEditor.vue?vue&type=script&lang=js&"
export * from "./AbcdQuestionEditor.vue?vue&type=script&lang=js&"
import style0 from "./AbcdQuestionEditor.vue?vue&type=style&index=0&id=2709d4b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2709d4b0",
  null
  
)

export default component.exports